import type { SearchResourceName } from "../types";
import type { RecentSearch } from "./recentSearches";
import { SEARCH_RESOURCES } from "./searchModel";

/** Lists the search can jump to, in tab-bar order. */
export const QUICK_LINKS: { name: SearchResourceName; url: string }[] = [
  { name: "contacts", url: "/contacts" },
  { name: "companies", url: "/companies" },
  { name: "deals", url: "/deals" },
  { name: "tasks", url: "/tasks" },
];

const DESCRIPTORS = new Map(SEARCH_RESOURCES.map((d) => [d.name, d]));

export const getDescriptor = (name: SearchResourceName) =>
  DESCRIPTORS.get(name) ?? SEARCH_RESOURCES[0];

/** cmdk value of a recent search row. */
export const recentValue = (entry: RecentSearch): string =>
  entry.type === "query"
    ? `recent.query.${entry.query}`
    : `recent.result.${entry.url}`;
